import { render, staticRenderFns } from "./DashboardQCView.vue?vue&type=template&id=2c606bdc&scoped=true&"
import script from "./DashboardQCView.vue?vue&type=script&lang=js&"
export * from "./DashboardQCView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardQCView.vue?vue&type=style&index=0&id=2c606bdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c606bdc",
  null
  
)

export default component.exports